import { Hospital, Region } from "./FetchTypes";
import regionData from '../__mocks__/regions.json';
import { transformDates, addNameAndValueProperties } from "./FetchFilterData";
export function getMonthsInbetween(startMonth: string, endMonth: string) {
	var monthNames = [
		'Januari',
		'Februari',
		'Mars',
		'April',
		'Maj',
		'Juni',
		'Juli',
		'Augusti',
		'September',
		'Oktober',
		'November',
		'December',
	];

	const months = [];
	const low = monthNames.indexOf(startMonth);
	const high = monthNames.indexOf(endMonth);
	for (let i = low; i <= high; i++) {
		months.push(monthNames[i]);
	}
	return months;
}


export function sortTestData(res: any) {
	const transformedDates: any = transformDates(res);
	const formattedData = addNameAndValueProperties(transformedDates);
	return formattedData;
}

export function getUnitDefault(res: any) {
	const result = res.regions.map((region: Region) => {
		return {
			value: region.regionId,
			name: region.regionName,
			hospitals: region.hospitals?.map((hosp: Hospital) => {
				return {
					value: hosp.hospitalId,
					name: hosp.hospitalName,
					hospitalService_ids: hosp.hospitalService_ids,
					hospitalCategory_ids: hosp.hospitalCategory_ids,
				};
			}),
		};
	});
	return result;
}

export function setDefaultValues(selector: string, element: any) {
	const addAllOption = (arr: any, text: string) =>
		arr.unshift({ name: text, value: -1 });

	let selectData;

	switch (selector) {
		case 'serviceSelect':
			if (element.phase) {
				if (element.phase === '0') {
					return;
				} else if (element.phase === '1') {
					selectData = element.storedData.filter.service;
				} else {
					selectData = element.storedData.filter.serviceExam;
				}
				// This is for over90 
			} else if (element.regionArea) {
				selectData = element.storedData.operations;
				addAllOption(selectData, 'Alla vårdutbud')
			} else if (element.storedData.services) {
				selectData = element.storedData.services;
			} else {
				selectData = element.storedData.visitServices
			}
			break;
		case 'regionSelect':
			selectData =
				element.storedData.region ||
				element.storedData.regions ||
				element.storedData.counties ||
				(element.services && element.services[0].regions) ||
				sortTestData(regionData).regionsWithClinics ||
				element.storedData.area[0].region;
			if (!element.selectors[selector].multiple)
				addAllOption(selectData, 'Alla regioner');
			break;
		case 'typeSelect':
			selectData = element.storedData.overbookedType || [
				{ name: 'Psykatri', value: 0 },
				{ name: 'Somatik', value: 1 },
			];
			break;
		case 'genderSelect':
			selectData = [
				{ value: -1, name: 'Kvinnor & Män' },
				{ value: 0, name: 'Kvinnor' },
				{ value: 1, name: 'Män' },
			];
			break;
		case 'ownerSelect':
		case 'managementSelect':
			selectData = [{ name: 'Alla ägarformer', value: -1 }, { name: 'Privat', value: 0 }, { name: 'Offentlig', value: 1 }];
			break;
		case 'productionSelect':
			selectData = [
				{ name: 'Väntande', value: 0 },
				{ name: 'Genomförda', value: 1 },
			];
			break;
		case 'professionSelect':
			selectData = element.storedData.profession;
			addAllOption(selectData, 'Alla yrken')
			break;
		case 'areaSelect':
			selectData = element.storedData.area;
			break;
		case 'careTypeSelect':
		case 'contactSelect':
			selectData = element.storedData.careType;
			if (!element.storedData.careType[0].value) {
				for (let i = 0; i < element.storedData.careType.length; i++) {
					element.storedData.careType[i].value = i
				}
			}
			addAllOption(selectData, 'Alla kontaktformer')
			break;
		case 'ageGroupSelect':
		case 'ageSelect':
			selectData = element.storedData.ageGroup;
			break;
		case 'categorySelect':
			if (element.phase === '0') {
				selectData = element.storedData.filter.visits;
			} else if (element.phase === '1') {
				selectData = element.storedData.filter.operations;
			} else if (element.phase === '2') {
				selectData = element.storedData.filter.exams;
			} else {
				selectData = element.storedData.category;
			}
			addAllOption(selectData, 'Alla specialiteter')
			break;
		case 'weekdaySelect':
			selectData = element.storedData.days;
			break;
		case 'timeIntervalSelect':
			selectData = element.storedData.timeInterval;
			break;
		case 'buttonSelect':
			selectData = element.storedData.serviceTypes;
			break;
		case 'specialitySelect':
			selectData = element.storedData.mvo;
			break;
		case 'indicatorSelect':
			selectData = [
				{ name: 'Medelväntetid (dagar)', value: 12 },
				{ name: 'Medianväntetid (dagar)', value: 13 },
			];
			break;
		case 'yearSelect':
		case 'yearStopSelect':
			let years;
			if (element.storedData.datesNationell && !element.monthlyReport) {
				years = element.storedData.datesNationell.years
			} else if (
				element.storedData.filter &&
				element.storedData.filter.dates.years
			) {
				years = element.storedData.filter.dates.years;
			} else if (
				element.storedData.datesSomatic &&
				element.storedData.datesPsychiatric
			) {
				years = element.storedData.datesSomatic.years;
			} else {
				years = [];
				for (
					let i = element.storedData.dates.startYear;
					i <= element.storedData.dates.endYear;
					i++
				) {
					years.push(i);
				}
			}
			selectData = years;
			break;
		case 'monthSelect':
			let months;
			if (element.storedData.datesNationell && !element.monthlyReport) {
				months = element.storedData.datesNationell.months
			} else if (
				element.storedData.filter &&
				element.storedData.filter.dates.months
			) {
				months = element.storedData.filter.dates.months;
			} else {
				months =
					element.storedData.datesSomatic &&
						element.storedData.datesPsychiatric
						? element.storedData.datesSomatic.months
						: getMonthsInbetween(
							'Januari',
							element.storedData.dates.endMonth
						);
			}
			selectData = months;
			break;
	}

	return selectData
}